import React, {FC} from 'react';

import {Checkbox} from '@zoefin/design-system';

import {useFhs, useFhsActor} from '../../store/FhsContext/hooks';
import type {FhsField} from '../../types';

import styles from './styles.module.scss';

interface QuestionCheckboxProps {
  field: FhsField;
  options: {label: string; value: string}[];
}

const QuestionCheckbox: FC<QuestionCheckboxProps> = ({field, options}) => {
  const actor = useFhsActor();
  const {formData, errors, touched} = useFhs();

  const raw = formData[field];
  const current = Array.isArray(raw) ? raw : [];
  // Built once rather than rescanned for every option rendered below.
  const selected = new Set(current);
  const error = touched[field] ? errors[field] : undefined;

  return (
    <div className={styles.questionCheckbox}>
      <div className={styles.questionCheckbox__grid}>
        {options.map((opt) => (
          <Checkbox
            key={opt.value}
            id={`fhs-${String(field)}-${opt.value}`}
            label={opt.label}
            checked={selected.has(opt.value)}
            className={styles.questionCheckbox__card}
            checkHandler={() =>
              actor.send({
                type: 'TOGGLE_MULTI_CHOICE',
                field,
                value: opt.value,
              })
            }
          />
        ))}
      </div>
      <div className={styles.questionCheckbox__errorSlot}>
        {error && <p className={styles.questionCheckbox__error}>{error}</p>}
      </div>
    </div>
  );
};

export default QuestionCheckbox;
